import DoF from './DoF';

export default {
  post() {
    return (
      <DoF />
    );
  },
};